import { defineMessages } from "react-intl";

const messages = defineMessages({
    h1: {
        id: "landing.hero.h1",
    },
    h2: {
        id: "landing.hero.h2",
    },
    start: {
        id: "landing.start",
    },
    recentPlans: {
        id: "landing.recentPlans",
    },
    morePlans: {
        id: "landing.morePlans",
    },
    stopwatch_soon: {
        id: "landing.stopwatch.soon",
    },
    lastChristmas: {
        id: "landing.hero.lastChristmas",
    },
    carousel1Title: {
        id: "landing.hero.carousel.1.title",
    },
    toMemory: {
        id: "landing.hero.toMemory",
    },
    toChoir: {
        id: "landing.hero.toChoir",
    },
    experienceAvailable: {
        id: "landing.hero.experienceAvailable"
    },
    newSubScore: {
        id: "landing.hero.newSubScore"
    },
    newExperienceChristmasTheme: {
        id: "landing.hero.experience.christmasTheme"
    },
    donationStripeTitle: {
        id: "donation.stripe.title"
    }
});

export default messages;
